import { useCallback } from 'react';
import { useNavigate } from 'react-router-dom';
import { useQueryClient } from '@tanstack/react-query';
import { authService } from '../services/authService';

export function useLogout() {
  const navigate = useNavigate();
  const queryClient = useQueryClient();

  return useCallback(async () => {
    try {
      await authService.logout();
    } catch {
      // Ignore — segue com o logout local de qualquer forma. A sessão e os
      // cookies já são revogados no servidor pelo POST /auth/logout.
    }
    // Limpa todo o cache do react-query (inclui a sessão em ['auth', 'me']).
    queryClient.clear();
    // Redireciona para o login via SPA com `replace`: o /dashboard sai do
    // histórico, então o botão "voltar" do navegador não retorna ao painel —
    // o ProtectedRoute exige novo login. Não fazemos o logout federado da
    // Microsoft de propósito (evita parar na página de OAuth da MS); o usuário
    // cai direto na tela de login da aplicação.
    navigate('/login', { replace: true });
  }, [navigate, queryClient]);
}
